import React, { useRef, useEffect, useState } from "react";
import { Fade } from "@material-ui/core";

import { ICategory } from "../../store/feedStoreTypes";
import { TranslationJSX } from "../../utils/Translation";
import { MuiChip, MuiBadge, ChipContainer, CategoryContainer } from "./style";

interface Props {
  list: ICategory[];
  buttonTheme: (id?: string) => string;
  onClickCategory: (id?: string, title?: string) => void;
}

const FeedsCategory = ({ list, buttonTheme, onClickCategory }: Props) => {
  const chipContainerRef = useRef<HTMLDivElement>(null);
  const [shadowType, setShadowType] = useState("right");

  const handleScroll = (event: any) => {
    const marginValue = 3;
    const elem = event.currentTarget;

    if (elem.scrollLeft + elem.clientWidth >= elem.scrollWidth - marginValue) {
      setShadowType("left");
    } else if (elem.scrollLeft <= marginValue) {
      setShadowType("right");
    } else {
      setShadowType("center");
    }
  };

  // history back으로 페이지 입장 시 rendering 이슈가 있어 element 찾지 못하면 setTimeout으로 함수 다시 실행하도록 함
  // scroll 시 shadow type 적용 event 등록, 해제
  const addScrollEvent = () => {
    chipContainerRef.current
      ? chipContainerRef.current.addEventListener("scroll", handleScroll)
      : setTimeout(addScrollEvent, 300);
  };
  const deleteScrollEvent = () => {
    chipContainerRef.current &&
      chipContainerRef.current.removeEventListener("scroll", handleScroll);
  };

  // active chip 찾아서 scroll
  const findActiveChip = () => {
    const activeChip = document.querySelector(".active");
    activeChip ? activeChip.scrollIntoView() : setTimeout(findActiveChip, 300);
  };

  useEffect(() => {
    addScrollEvent();
    findActiveChip();
    return () => {
      deleteScrollEvent();
    };
    // eslint-disable-next-line
  }, []);

  return (
    <Fade in>
      <CategoryContainer shadowType={shadowType}>
        <ChipContainer ref={chipContainerRef}>
          <MuiChip
            label={<TranslationJSX locoKey="feed_category_all" />}
            className={buttonTheme()}
            onClick={() => onClickCategory()}
          />
          {list.map((item) => (
            <MuiBadge
              variant="dot"
              color="secondary"
              invisible={item.badge}
              key={item.categoryId}
            >
              <MuiChip
                dir="auto"
                id={item.categoryId}
                label={item.translation.title}
                className={buttonTheme(item.categoryId)}
                onClick={() =>
                  onClickCategory(item.categoryId, item.translation.title)
                }
              />
            </MuiBadge>
          ))}
        </ChipContainer>
      </CategoryContainer>
    </Fade>
  );
};

export default FeedsCategory;
